import React, { useMemo } from 'react';

// store
import { useStoreValue } from '../../../../../../../../store';
import { startExternalDrag } from '../../../../../../../../store/externalDragStore';

// tools
import getDateFromISOstring from '../../../../../../../../helpers/getDateFromISOstring';

// components
import TripleDotsIcon from '../../../../../../../../icons/TripleDotsIcon';
import ButtonIconSimple from '../../../../../../../../components/ButtonWrapper/components/ButtonIconSimple';
import LikeIcon from '../../../../../../../../icons/LikeIcon';
import ToReviewIcon from '../../../../../../../../icons/ToReviewIcon';
import DislikeIcon from '../../../../../../../../icons/DislikeIcon';
import Mix2Icon from '../../../../../../../../icons/Mix2Icon';
import ButtonIconContextMenu from '../../../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';

const ListOfMixItems = () => {
    const cueSheet = useStoreValue('cueSheet');
    const mixItems = useMemo(() => {
        return cueSheet.filter(o => o.cueType === 'MIX' && o.clip)
    }, [cueSheet]);

    return(
        mixItems.map(item => <li key={`mix_${item.id}`}
            style={{ cursor: 'grab' }}
            onMouseDown={(e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                startExternalDrag(item, e.clientX, e.clientY);
            }}
        >
            <div className="icon">
                <Mix2Icon/>
            </div>
            <div className="title">
                <h3>{item.title}</h3>
                <span>{item.timecode}</span>
            </div>
            <div className="rating lastGroup">
                <ButtonIconSimple>
                    <LikeIcon/>
                </ButtonIconSimple>
                <ButtonIconSimple>
                    <ToReviewIcon/>
                </ButtonIconSimple>
                <ButtonIconSimple>
                    <DislikeIcon/>
                </ButtonIconSimple>
            </div>
            <div className="meta">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                <ButtonIconContextMenu>
                    <TripleDotsIcon/>
                </ButtonIconContextMenu>
            </div>
        </li>)
    )
}

export default ListOfMixItems;